import * as React from 'react';

import { Alert, AlertNotFoundIcon } from '../../../../components/Alert';
import { ADDRESS_NOT_FOUND_ALERT } from '../../const';

export const AddressNotFoundAlert: React.FC = () => {
  const { title, message, testId } = ADDRESS_NOT_FOUND_ALERT;

  return <Alert icon={<AlertNotFoundIcon />} title={title} message={message} testId={testId} />;
};
